// loginErrorHandler.js

// Simple email format validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateLoginInput(email, password) {
  if (!email && !password) {
    return "Please enter email and password.";
  }
  if (!email) {
    return "Please enter your email address.";
  }
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  if (!password) {
    return "Please enter your password.";
  }
  return null; // no validation errors
}

export function parseLoginError(error) {
  const status = error?.status;

  if (!status) {
    return "An unexpected error occurred. Please try again later.";
  }

  switch (status) {
    case 400:
      return "Invalid request. Please check your input.";
    case 401:
      return "Incorrect email or password. Please try again.";
    case 403:
      return "Access denied. Please contact support.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service is temporarily unavailable. Please wait a moment and try again.";
    default:
      return "An error occurred. Please try again.";
  }
}
